export const operatorAssets = [
  'Subscriber base',
  'Business customers',
  'Existing billing relationship',
  'Existing telecom infrastructure',
]

export const distributedProducts = [
  { name: 'VEXU App', descriptor: 'AI communication for subscribers' },
  {
    name: 'VEXU Business',
    descriptor: 'AI communications for SMEs & businesses',
  },
]

export const whyTelecom = [
  {
    title: 'Distribution',
    detail: 'Access existing subscriber & business bases',
  },
  { title: 'Billing', detail: 'Potential operator-bundled subscriptions' },
  {
    title: 'Infrastructure',
    detail: 'VEXU complements the telecom layer it already operates on',
  },
]

/** Expansion opportunities — not signed partnerships. */
export const regionalStages = [
  { index: '01', name: 'UAE', detail: 'Near-term telecom opportunity' },
  { index: '02', name: 'Jordan', detail: 'Near-term telecom opportunity' },
  { index: '03', name: 'Regional expansion', detail: 'GCC & wider MENA' },
]
